import { Button } from '@/components/common/Button';
import useLanguage from '@/utils/hooks/useLanguage';
import React from 'react';
import { MdChevronLeft, MdChevronRight, MdClose } from 'react-icons/md';

interface StepButtonsProps {
    canGoBack: boolean;
    canGoForward: boolean;
    onNext: () => void;
    onPrev: () => void;
    onSkip: () => void;
    isLastStep?: boolean;
}

const StepButtons: React.FC<StepButtonsProps> = ({ canGoBack, canGoForward, onNext, onPrev, onSkip, isLastStep }) => {
    const lang = useLanguage();

    return (
        <div className="mt-6 flex items-center justify-between gap-3">
            <Button
                type="button"
                disabled={!canGoBack}
                onClick={onPrev}
                aria-label={lang.onboardingUi.previousStepAria}
                className="w-auto bg-transparent px-3 py-2 text-brand-neutral-300 hover:bg-brand-neutral-700">
                <span className="flex items-center gap-2">
                    <MdChevronLeft size={18} />
                    {lang.onboardingUi.previous}
                </span>
            </Button>

            <div className="flex items-center gap-2">
                {!isLastStep && (
                    <Button
                        type="button"
                        onClick={onSkip}
                        aria-label={lang.onboardingUi.skipTour}
                        className="w-auto !bg-transparent px-3 py-2 text-brand-neutral-200 hover:border-brand-neutral-500 hover:!bg-brand-neutral-700 !ring-0">
                        <span className="flex items-center gap-2">
                            <MdClose size={18} />
                            {lang.onboardingUi.skipTour}
                        </span>
                    </Button>
                )}

                <Button
                    type="button"
                    disabled={!canGoForward}
                    onClick={onNext}
                    aria-label={isLastStep ? lang.onboardingUi.completeTourAria : lang.onboardingUi.nextStepAria}
                    className="w-auto px-4 py-2">
                    <span className="flex items-center gap-2">
                        {isLastStep ? lang.onboardingUi.finishTour : lang.onboardingUi.next}
                        {!isLastStep && <MdChevronRight size={18} />}
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default StepButtons;
